.preview-image {
    max-width: 100%;
    max-height: 650px;
    object-fit: contain;
    height: 100%;
}

.disabled-container {
    position: absolute;
    display: flex;
    width: 35%;
    height: 108px;
    padding: 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background: var(--grey-dk);
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
}

.icon-image {
    width: 34px;
    height: 34px;
    object-fit: cover;
}
